// Copyright 2026 FlairCV Contributors
// SPDX-License-Identifier: AGPL-3.0-or-later

import createOpenAPIClient from 'openapi-fetch';
import type { paths } from './schema';

/**
 * Creates a type-safe API client instance.
 * The base URL should be provided by the consuming application.
 */
export function createClient(baseUrl: string = '/api/v1') {
  return createOpenAPIClient<paths>({ baseUrl });
}
